export default __webpack_public_path__ + "static/O0172-e49480841b80790317fba39ab723380b.png";